import {
  formatToMoney,
  formatCurrencyAndTwoDecimalsString
} from "../../../../lib/formatter";

export class ConferenceSearchPerDate {
  constructor(conferenceProject) {
    const person = "ท่าน";

    let dateSelect = "-";
    let conferenceProjectByDate = {};
    const dateKeys = Object.keys(conferenceProject);
    if (dateKeys.length > 0) {
      dateSelect = dateKeys[dateKeys.length - 1];
      conferenceProjectByDate = conferenceProject;
    }

    const conferenceProjects =
      conferenceProjectByDate[dateSelect] &&
      conferenceProjectByDate[dateSelect].length > 0
        ? conferenceProjectByDate[dateSelect]
        : [];

    const conferenceProjectListByDate = conferenceProjects
      ? conferenceProjects.map((project) => {
          let limitPeople = "-";
          if (project.limit) {
            if (project.limit.from && project.limit.to) {
              limitPeople = `${project.limit.from} - ${project.limit.to}`;
            } else if (project.limit.from) {
              limitPeople = project.limit.from;
            }
          }

          const pricePackagePerUnitText = `${formatCurrencyAndTwoDecimalsString(
            project.price_package_per_unit,
            2,
            "฿"
          )}/${person}`;

          return {
            conferenceId: project.id,
            title: project.title || "-",
            detail: project.detail || "-",
            image: project.images[0],
            limit: `${limitPeople} ${person}`,
            address: project.address || "-",
            conferencePrice:
              formatToMoney(project.price, 2, "$") || "",
            conferencePricePackagePerUnit: pricePackagePerUnitText
          };
      })
      : [];

    this.dateSelect = dateSelect;
    this.conferenceProjectListByDate = conferenceProjectListByDate;
  }
}
